import BBPromise from 'bluebird';

import React from 'react';
import { createRoot } from 'react-dom/client';
import Modal from 'react-modal';

// Polyfill for Fetch for super old chrome.
import 'unfetch/polyfill';

import { applyRemoteComplianceConfig } from 'shared/core/helpers/compliance-remote-config';
import { initializeRum } from 'src/utils/rum';
import Root, { initializeLDProvider } from 'src/root';

// CURRENT_VERSION is replaced by Webpack & represents the version of the JS at build time
// eslint-disable-next-line no-undef
const currentVersion = CURRENT_VERSION;

initializeRum(currentVersion);

BBPromise.config({ cancellation: true });

// Apply the remote compliance config (delivered via react-env) before the app renders.
applyRemoteComplianceConfig();

document.addEventListener('DOMContentLoaded', async () => {
  const renderTarget = document.getElementById('render-target');
  Modal.setAppElement(renderTarget);

  // Initialize LaunchDarkly before rendering to ensure flags are available
  const LDProvider = await initializeLDProvider();

  const root = createRoot(renderTarget);
  root.render(
    <LDProvider>
      <Root currentVersion={currentVersion} />
    </LDProvider>
  );
});
